// extracted by mini-css-extract-plugin
export default {"item":"Containers_item__O4XqD","itemFocus":"Containers_itemFocus__jszK5"};